import {Box, Divider, Grid} from '@material-ui/core'
import {AttachFile, InsertPhoto, PictureAsPdf} from '@material-ui/icons'
import _t, {_} from 'i18n'
import React, {Fragment} from 'react'
import {Button, Form} from 'react-bootstrap'

import {Container, Title} from '../styles'

const formatCurrency = (amount) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount)

const ProposalRevision = ({proposal, onSubmit, submiting}) => {
  return (
    <Container style={{padding: 0}}>
      <Box marginBottom="60px" maxWidth="654px" m="auto" width="100%">
        <Grid container direction="column">
          <Box>
            <Box marginBottom="5px">
              <Title>{_`TIPO DA OPORTUNIDADE`}</Title>
            </Box>
            <Box display="flex" width="fit-content" flexDirection="column" mb="20px">
              <Form.Label>{proposal.type === 'company' ? _`Privada` : _`Pública`}</Form.Label>
            </Box>
            <Divider />
          </Box>

          <BlockDetail
            title={_`DETALHES DA OPORTUNIDADE`}
            items={[
              {label: _`Nome`, value: proposal.name},
              {
                label: _`Vinculada a`,
                value: proposal.city ? `${proposal.city.name} - ${proposal.city.state.uf}` : null,
              },
            ]}
          />

          {proposal.benefits.length && (
            <BlockDetailBenefityList title={_`INCENTIVOS DISPONÍVEIS AO INVESTIDOR`} items={proposal.benefits} />
          )}

          {proposal.benefits.length && <BlockDetailBenefity title={_`BENEFÍCIOS`} items={proposal.benefits} />}

          {proposal.project && (
            <BlockDetail
              title={_`DADOS DA EMPRESA`}
              items={[
                {label: _`Razao Social`, value: proposal.project.company.name},
                {
                  label: _`Capital Social`,
                  value: proposal.project?.company?.share_capital
                    ? formatCurrency(proposal.project.company.share_capital)
                    : null,
                },
                {label: _`CNPJ`, value: proposal.project?.company?.federal_tax_id},
                {
                  label: _`Atividade Econômica (CNAE Primário)`,
                  value: proposal.project?.company?.main_activity_description,
                },
              ]}
            />
          )}

          {proposal.project && (
            <BlockDetail
              title={_`ENDEREÇO DA OPORTUNIDADE`}
              items={[
                {label: _`CEP`, value: proposal.project.company?.address?.zip},
                {label: _`Número`, value: proposal.project.company?.address?.number},
                {label: _`Bairro`, value: proposal.project.company?.address?.neighborhood},
                {label: _`Estado`, value: proposal.project?.company?.address?.state?.uf},
                {label: _`Município`, value: proposal.project.company?.address?.city?.name},
              ]}
            />
          )}

          <BlockDetail
            title={_`CONTATO`}
            items={[
              {label: _`Nome para contato`, value: proposal.contacts[0]?.name},
              {label: _`Cargo`, value: proposal.contacts[0]?.responsibility},
              {label: _`Telefone`, value: proposal.contacts[0]?.phone},
              {label: _`E-mail`, value: proposal.contacts[0]?.email},
              {label: _`Site`, value: proposal.contacts[0]?.linkedin},
            ]}
          />

          {proposal.project && (
            <BlockDetail
              title={_`DESCRIÇÃO DO PROJETO`}
              items={[
                {
                  label: _`Categoria da oportunidade`,
                  value: proposal.project.category_description
                    ? proposal.project.category_description
                    : proposal.project.category,
                },
                {
                  label: _`Valor total do investimento a ser realizado`,
                  value: proposal.project?.total ? formatCurrency(proposal.project?.total) : null,
                },
                {
                  label: _`Valor de necessidade do investimento`,
                  value: proposal.project?.required_investment
                    ? formatCurrency(proposal.project?.required_investment)
                    : null,
                },
                {label: _`Breve descrição do projeto`, value: proposal.project?.description},
              ]}
            />
          )}

          <Box pt="30px">
            <Box mb="22px">
              <Title>{_`ANEXOS`}</Title>
            </Box>
            <Box display="flex" gridGap="15px" flexWrap="wrap" justifyContent="space-between">
              {proposal.multimedia.map((file) => (
                <Tip key={`${file.id || file.name}`} description={file.name} />
              ))}
            </Box>
          </Box>

          <Box display="flex" marginTop="70px" marginBottom="70px">
            <Box>
              <Button onClick={() => onSubmit(false)} disabled={submiting}>
                {_`SALVAR E CONCLUIR EDIÇÃO`}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Container>
  )
}

const BlockDetail = ({title, items}) => {
  return (
    <Fragment>
      <Box pt="30px" pb="30px">
        <Box mb="5px">
          <Title>{title}</Title>
        </Box>

        {items?.map((item, index) => (
          <Detail key={`${item.label || 'detail'}-${index}`} {...item} />
        ))}
      </Box>
      <Divider />
    </Fragment>
  )
}

const BlockDetailBenefityList = ({title, items}) => {
  return (
    <Fragment>
      <Box pt="30px" pb="30px">
        <Box mb="5px">
          <Title>{title}</Title>
        </Box>

        {items?.map((item, index) => (
          <Detail key={`${item.type}-${index}`} label={item.type.toUpperCase()} />
        ))}
      </Box>
      <Divider />
    </Fragment>
  )
}

const BlockDetailBenefity = ({title, items}) => {
  return items.map((item, index) => {
    if (item.type === 'terreno') {
      return (
        <Fragment key={`${item.type}-${index}`}>
          <Box pt="30px" pb="30px">
            <Box mb="5px">
              <Title>{_`SOBRE O TERRENO`}</Title>
            </Box>
            <Detail label={_`Identificação`} value={item.identification} />
            <Detail label={_`Área'`} value={item.area} />
            <Detail
              label={_`Valor Estimado`}
              value={item.estimated_value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                style: 'currency',
                currency: 'BRL',
              })}
            />
            <Detail label={_`Restrições`} value={item.restrictions} />
            <Detail label={_`URL Mapa`} value={item.url_map} />
          </Box>
          <Divider />
          <Box pt="30px" pb="30px">
            <Box mb="5px">
              <Title>{_`DETALHAMENTO`}</Title>
            </Box>
            <Detail value={item.description} />
          </Box>
          <Divider />
        </Fragment>
      )
    }

    return (
      <Fragment key={`${item.type}-${index}`}>
        <Box pt="30px" pb="30px">
          <Box mb="5px">
            <Title>{_t('SOBRE INCENTIVO {type}', {type: item.type.toUpperCase()})}</Title>
          </Box>
          <Detail value={item.description} />
        </Box>
        <Divider />
      </Fragment>
    )
  })
}

const Detail = ({label, value}) => {
  return (
    <Box
      style={{
        color: '#1D1D1D',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
      }}>
      <b>
        {label}
        {label && value ? ':' : null}{' '}
      </b>{' '}
      {value}
    </Box>
  )
}

const Tip = ({description}) => {
  return (
    <Box
      padding="2px 10px"
      width="fit-content"
      fontSize="12px"
      borderRadius="10px"
      display="flex"
      alignItems="center"
      style={{backgroundColor: '#1E7BE10C'}}>
      {(function () {
        switch (description.split('.')[description.split('.').length - 1]) {
          case 'pdf':
            return <PictureAsPdf />
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'bmp':
          case 'gif':
            return <InsertPhoto />
          case 'doc':
          case 'docx':
          case 'xls':
          case 'xlsx':
          case 'txt':
            return <AttachFile />
          default:
            return <AttachFile />
        }
      })()}
      <p style={{margin: '0 0 0 4px'}}>{description}</p>
    </Box>
  )
}

export default ProposalRevision
